import React from "react";

export default function SQL_HAVING() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_HAVING</h1>
      <p>This is the SQL_HAVING component generated from the SQL JSON.</p>
    </div>
  );
}
